import { createFileRoute, Link } from "@tanstack/react-router";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";


export const Route = createFileRoute("/404")({
  component: NotFoundPage,
});

export function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="sm" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "1.5rem", md: "2.5rem" },
              fontWeight: 500,
              color: "text.secondary",
              mb: 1,
              opacity: 0.5,
            }}
          >
            404
          </Typography>
          <Typography
            variant="h2"
            sx={{
              mb: 2,
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: 800,
              background: (theme) =>
                `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Page Not Found
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 400, mx: "auto" }}
          >
            The page you're looking for doesn't exist or has been moved. Let's
            get you back on track.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/"
              startIcon={<HomeIcon />}
            >
              Back to Home
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={Link}
              to="/contact-us"
              startIcon={<SearchIcon />}
            >
              Contact Support
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
